import template from './view-cart-error-messages.html';
import controller from './view-cart-error-messages.controller';

let viewCartErrorMessagesComponent = {
    restrict: 'E',
    bindings: {
        errorTypes: '<',
        cartErrors: '<',
        shoppingCartForm: '<'
    },
    template,
    controller
};

export default viewCartErrorMessagesComponent;


// WEBPACK FOOTER //
// ./src/app/components/view-cart/view-cart-error-messages/view-cart-error-messages.component.js